import React, { useContext } from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

import { BlogCardContext } from './BlogCardContext';

const colorAnimation =
  'group-hover:bg-blue-51 transition duration-300 ease-in-out bg-white';
export const BlogCardContent = ({
  children,
  className,
  as: Component = 'div',
  ...props
}: DefaultBsComponent) => {
  const context = useContext<any>(BlogCardContext);

  return (
    <Component
      className={classNames(
        'BlogCardContent',
        'h-full',
        className,
        context?.imgPosition === 'top' &&
          'md:bottom-0 md:rounded-t-none md:border-t-0',
        context?.imgPosition === 'bottom' &&
          'md:top-0 md:rounded-b-none md:border-b-0',
        ['none'].includes(context?.imgPosition) &&
          `${colorAnimation} px-24 py-32`,
        ['top', 'bottom'].includes(context?.imgPosition) &&
          `${colorAnimation} flex w-full flex-1 flex-col rounded-18 px-24 py-32`,
        ['right', 'left'].includes(context?.imgPosition) &&
          'relative flex flex-col justify-center md:w-1/2',
      )}
      {...props}
    >
      {children}
    </Component>
  );
};
